import { Component, h, tag } from "omi";

import { tailwind } from "@/tailwind";

@tag("nw-validation-success")
export class NWValidationSuccess extends Component {
  static css = [tailwind];

  render() {
    // TODO Ask Jon about the background color being too light
    return (
      <div className="bg-brand-50 px-10 py-8 rounded-2xl flex flex-col items-center justify-center">
        <p className="text-primary">Thanks! Time for a boogie 🕺</p>
        <img className="w-40 h-40" src="/static/animations/cat-dancing.gif" alt="Cat dancing animation" />
      </div>
    );
  }
}
